import React, { useState } from 'react';
import { Box, Tabs, Tab, Typography, Paper } from '@mui/material';
import PerformanceOverTime from './PerformanceOverTime';
import TeamPerformance from './TeamPerformance';
import ConsensusAnalysis from './ConsensusAnalysis';
import BoldPicksAnalysis from './BoldPicksAnalysis';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`analysis-tabpanel-${index}`}
      aria-labelledby={`analysis-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

interface AnalysisViewProps {
  season: number;
}

const AnalysisView: React.FC<AnalysisViewProps> = ({ season }) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={{ width: '100%', maxWidth: '1400px', margin: '0 auto', padding: 3 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Analysis - {season} Season
      </Typography>

      <Paper elevation={2} sx={{ mt: 3 }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            aria-label="analysis tabs"
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label="Performance Over Time" id="analysis-tab-0" />
            <Tab label="Team Performance" id="analysis-tab-1" />
            <Tab label="Wisdom of Crowd" id="analysis-tab-2" />
            <Tab label="Bold Picks" id="analysis-tab-3" />
          </Tabs>
        </Box>

        <TabPanel value={activeTab} index={0}>
          <PerformanceOverTime season={season} />
        </TabPanel>
        <TabPanel value={activeTab} index={1}>
          <TeamPerformance season={season} />
        </TabPanel>
        <TabPanel value={activeTab} index={2}>
          <ConsensusAnalysis season={season} />
        </TabPanel>
        <TabPanel value={activeTab} index={3}>
          <BoldPicksAnalysis season={season} />
        </TabPanel>
      </Paper>
    </Box>
  );
};

export default AnalysisView;
